import * as React from "react";
import { Check, CaretUpDown } from "@phosphor-icons/react";
import { Button } from "@finance/components/ui/button";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@finance/components/ui/command";
import { Popover, PopoverContent, PopoverTrigger } from "@finance/components/ui/popover";
import { cn } from "@finance/lib/utils";

/**
 * Type-to-filter dropdown. `options` = [{ value, label }].
 * Drop-in for the common shadcn Select where the list is long.
 */
export function SearchableSelect({ value, onValueChange, options = [], placeholder = "Select", testid, className, disabled }) {
  const [open, setOpen] = React.useState(false);
  const selected = options.find((o) => String(o.value) === String(value));
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button type="button" variant="outline" role="combobox" disabled={disabled} data-testid={testid}
          className={cn(
            "w-full justify-between font-normal hover:bg-transparent hover:text-inherit",
            "focus-visible:ring-2 focus-visible:ring-[#1B4383]/30 focus-visible:border-[#1B4383]",
            "data-[state=open]:border-[#1B4383] data-[state=open]:ring-2 data-[state=open]:ring-[#1B4383]/30",
            !selected && "text-gray-400", className,
          )}>
          <span className="truncate">{selected ? selected.label : placeholder}</span>
          <CaretUpDown size={14} className="ml-2 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="min-w-[--radix-popover-trigger-width] w-auto max-w-[min(90vw,32rem)] p-0" align="start">
        <Command filter={(value, search) => {
          const v = value.toLowerCase();
          return search.toLowerCase().split(/\s+/).filter(Boolean).every((t) => v.includes(t)) ? 1 : 0;
        }}>
          <CommandInput placeholder="Type to search…" data-testid={testid ? `${testid}-search` : undefined} />
          <CommandList>
            <CommandEmpty>No match found.</CommandEmpty>
            <CommandGroup>
              {options.map((o) => (
                <CommandItem key={o.value} value={`${o.label} ${o.value}`}
                  disabled={!!o.disabled}
                  onSelect={() => { if (o.disabled) return; onValueChange?.(o.value); setOpen(false); }}
                  data-testid={testid ? `${testid}-opt-${o.value}` : undefined}>
                  <Check size={14} className={cn("mr-2 shrink-0", String(value) === String(o.value) ? "opacity-100" : "opacity-0")} />
                  <span className="whitespace-normal break-words">{o.label}</span>
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
